/**
 * Provides helper functions for handling custom popups on map 2.0
 *
 * @mixin
 */
window.CustomPopupHelper = (() => {
    let _panCustomPopupsFrame;

    return {
        movingOriginPoint: undefined,
        isPanPending: false,

        addCustomPopup(graphic, titleHtml = '', contentHtml = '') {
            const $popupDiv = $(
                `<div id="${Date.now()}" class="map-tooltip map-tooltip-popover"></div>`
            );
            graphic.popup = $popupDiv[0];

            // Save for retrieval when we only have the DOM element.
            $popupDiv.data({ graphic });

            this.updateCustomPopup(graphic, titleHtml, contentHtml);
            this.popupContainer.append($popupDiv);
        },

        updateCustomPopup(graphic, titleHtml = '', contentHtml = '') {
            const $popupDiv = $(graphic.popup);
            $popupDiv.html(_getPopupHtml(graphic.popup.id, titleHtml, contentHtml));
            _updatePopupPosition.call(this, $popupDiv);
        },

        hideCustomPopup(graphic) {
            return graphic.popup && $(graphic.popup).hide();
        },

        hideCustomPopups() {
            return this.popupContainer.hide();
        },

        removeCustomPopups() {
            $('.map-tooltip-popover').remove();
        },

        removeCustomPopup(graphic) {
            graphic.popup && $(graphic.popup).remove();
        },

        panCustomPopups() {
            if (this.isPanPending) {
                return;
            }
            this.isPanPending = true;

            // Save map Point of the upper left corner of viewport.
            this.movingOriginPoint = this.view.toMap(this.originScreenPoint);

            if (!_panCustomPopupsFrame) {
                _panCustomPopupsFrame = _translateCustomPopupsAndRequeue.bind(this);
            }

            requestAnimationFrame(_panCustomPopupsFrame);
        },

        repositionCustomPopups() {
            return this.popupContainer
                .find('.map-tooltip')
                .each((_, el) => _updatePopupPosition.call(this, $(el)))
                .end()
                .show();
        }
    };

    function _getPopupHtml(id, titleHtml, contentHtml) {
        return `
            <div class="bootstrap">
                <div class="popover" id="${id}">
                    <h3 class="popover-title">
                        ${titleHtml}
                        <button type="button" id="close" class="close" onclick="$('#${id}').remove();">
                            &times;
                        </button>
                    </h3>
                    <div class="popover-content">${contentHtml}</div>
                </div>
            </div>
        `;
    }

    function _getPopupOpenLocation(geometry) {
        // Picking the lower right corner as the open location to make sure that the popup
        // doesn't overlap with the geometry or the map's filter panels
        const lowerRightCorner = {
            spatialReference: geometry.spatialReference,
            x: geometry.extent.xmax,
            y: geometry.extent.ymin
        };

        const { x, y } = this.view.toScreen(lowerRightCorner);

        return { left: x, top: y };
    }

    function _updatePopupPosition($popup) {
        const { graphic } = $popup.data();
        if (!graphic) {
            return;
        }

        const { left: openLeft, top: openTop } = _getPopupOpenLocation.call(this, graphic.geometry);
        const { x: offsetLeft, y: offsetTop } = this.popupContainerOffset;

        $popup.css({ left: openLeft - offsetLeft, top: openTop - offsetTop, display: 'block' });
    }

    function _translateCustomPopupsAndRequeue() {
        this.isPanPending = false;

        // Get the pixel distance the saved map Point moved.
        const { x, y } = this.view.toScreen(this.movingOriginPoint);

        if (x !== 0 || y !== 0) {
            const offset = this.popupContainerOffset;
            offset.x += x;
            offset.y += y;

            this.popupContainer.css({
                transform: `translate(${offset.x}px, ${offset.y}px)`,
                display: 'block'
            });
        }

        // Can't test `this.view.interacting` b/c it is false after user "throws" the map.
        if (!this.view.stationary) {
            this.panCustomPopups();
        }
    }
})();
